const ASSETS_BASE_URL = 'https://assets.wiseupfood.com/media/'
// const VIDEO_URL ="https://results-wiseupfood.s3.amazonaws.com/"
// const VIDEO_URL = 'https://dh7jinrdd8ia3.cloudfront.net/'
const VIDEO_URL = 'https://video.wiseupfood.com/'
export const environment: any = {
  production: false,
  logoImagePath: 'assets/images/logo.png',
  // Dev server
  baseUrl: 'https://devadmin.wiseupfood.com/',
  apiUrl: 'https://devadminapi.wiseupfood.com/',
  // Live server
  // baseUrl: 'https://admin.wiseupfood.com/',
  // apiUrl: 'https://api.wiseupfood.com/',
  // apiUrl: 'https://prodapi.wiseupfood.com/',
  brandAdminBaseUrl: 'https://brand.wiseupfood.com/',
  csv: 'assets/file/Brand_Creation _Template.csv',
  secretKey: '1234567890',
  dietary: ASSETS_BASE_URL + 'products/dietary_alerts/icons/',
  brandImage: ASSETS_BASE_URL + 'brands/',
  brandThumbImage: ASSETS_BASE_URL + 'brands/thumbs/',
  brandNoImage: 'assets/images/no-logo.png',
  productImage: ASSETS_BASE_URL + 'products/images/',
  productThumbImage: ASSETS_BASE_URL + 'products/images/thumbs/',
  productNoImage: 'assets/images/product.png',
  userImage: ASSETS_BASE_URL + 'customers/',
  userNoImage: 'assets/images/user.jpg',
  recipesImage: ASSETS_BASE_URL + 'recipes/images/',
  recipesThumbImage: ASSETS_BASE_URL + 'recipes/images/thumbs/',
  recipesNoImage: 'assets/images/no-recipes.png',
  adminImage: ASSETS_BASE_URL + 'admin/images/',
  productVideoPath: VIDEO_URL,
  productImagePath: ASSETS_BASE_URL + 'products/videos/',
  sourceVideoPath: VIDEO_URL,
  contentImagePath: ASSETS_BASE_URL + 'content/images/',
  contentvideoPath: VIDEO_URL,
  websiteLogoPath: ASSETS_BASE_URL + 'content/images/',
  website_banner_path: ASSETS_BASE_URL + 'content/images/',
  logoNoImage: 'assets/images/no-image.png',
  noLogo: 'assets/images/up-no-logo.png',
  contentVideoThumbnailPath: ASSETS_BASE_URL + 'content/videos/',
  brandDocumentsPath: ASSETS_BASE_URL + 'brands/documents/',
  noUploadImg: 'assets/images/up-no-doc.png',
  productQrcodePath: ASSETS_BASE_URL + 'products/qrcode/',
  noQrCode: 'assets/images/QR-code.png',
  qrcodeLogoPath: ASSETS_BASE_URL + 'qrcode/logos/',
  qrcodeDesignPath: ASSETS_BASE_URL + 'qrcode/design/',
  qrcodeNoImage: 'assets/images/Qr-whole-chicken.png',
  productDetailPath: 'http://staging.wiseupfood.com/products/',
  noUserImg: 'assets/images/up-no-img.png',
  faviconImagePath: ASSETS_BASE_URL + 'content/images/',
  noFaviconImage: 'assets/images/up-no-img.png',
  brandAdminImage: ASSETS_BASE_URL + 'brands_admin/',
  couponsImagePath: ASSETS_BASE_URL + 'products/coupons/',
  undefinedImagePath: ASSETS_BASE_URL + 'products/undefined/',
  editUndefinedImagePath: ASSETS_BASE_URL,
  couponBarcodeImagePath: ASSETS_BASE_URL + 'products/coupons/barcode_images/',
  couponProductImagePath: ASSETS_BASE_URL + 'products/coupons/product_images/',
  s3CsvPath: "https://s3.amazonaws.com/content.wiseupfood.com/media/qr_code_scan/report/",
  googleApiKey: 'AIzaSyANp1gacZewUy0SjwF2FOoa0lLnzkCyBeY'


  // apiUrl: 'https://api.wiseupfood.com/',
  // secretKey: '1234567890',
  // brandImage: 'https://www.wiseupfood.com/media/brands/',
  // brandNoImage: 'assets/images/no-logo.png',
  // productImage: 'https://www.wiseupfood.com/media/products/images/',
  // productNoImage: 'assets/images/product.png',
  // userImage: 'https://www.wiseupfood.com/media/customers/',
  // userNoImage: 'assets/images/user.jpg',
  // recipesImage: 'https://www.wiseupfood.com/media/recipes/images/',
  // recipesNoImage: 'assets/images/no-recipes.png',
  // adminImage: 'https://www.wiseupfood.com/media/admin/images/',
  // productVideoPath: 'https://www.wiseupfood.com/media/products/videos/',
  // contentImagePath: 'https://www.wiseupfood.com/media/content/images/',
  // contentvideoPath: 'https://www.wiseupfood.com/media/content/videos/',
  // websiteLogoPath: 'https://www.wiseupfood.com/media/content/images/',
  // website_banner_path: 'https://www.wiseupfood.com/media/content/images/',
  // logoNoImage: 'assets/images/no-image.png',
  // sourceVideoPath: 'https://www.wiseupfood.com/media/products/videos/',
  // noLogo: 'assets/images/up-no-logo.png',
  // contentVideoThumbnailPath: 'https://www.wiseupfood.com/media/content/videos/',
  // brandDocumentsPath: 'https://www.wiseupfood.com/media/brands/documents/',
  // noUploadImg: 'assets/images/up-no-doc.png',
  // productQrcodePath: 'https://www.wiseupfood.com/media/products/qrcode/',
  // noQrCode: 'assets/images/QR-code.png',
  // qrcodeLogoPath: 'https://www.wiseupfood.com/media/qrcode/logos/',
  // qrcodeDesignPath: 'https://www.wiseupfood.com/media/qrcode/design/',
  // qrcodeNoImage: 'assets/images/QR-code.png',
  // productDetailPath: 'https://wiseupfood.com/products/',
  // noUserImg: 'assets/images/up-no-img.png',
  // faviconImagePath: 'https://www.wiseupfood.com/media/content/images/',
  // noFaviconImage: 'assets/images/up-no-img.png',
  // brandAdminImage: 'https://www.wiseupfood.com/media/brands_admin/',
  // couponsImagePath: 'https://www.wiseupfood.com/media/products/coupons/',
  // undefinedImagePath: 'https://www.wiseupfood.com/media/products/undefined/',
  // couponBarcodeImagePath:
  //   'https://www.wiseupfood.com/media/products/coupons/barcode_images/',
  //   couponProductImagePath:
  //   'https://www.wiseupfood.com/media/products/coupons/product_images/',
}
